import { ArrowCircleGray500Icon } from '@assets/iconComponents';
import { Text } from '..';
import { colorSet } from '@theme';
import { useAdultsOnlyActions, useStandardActions } from '@remote-hooks';
import { useLocation } from 'react-router';
import { PathnameEnum } from '@constant';
import { CSSProperties } from 'react';

interface ISearchResetButtonProps {
  boxstyle?: CSSProperties;
}

export const SearchResetButton = (props: ISearchResetButtonProps) => {
  const { boxstyle } = props;

  const { onInitStandard } = useStandardActions();
  const { onInitAdultsOnly } = useAdultsOnlyActions();

  const location = useLocation();
  const locationPathname = location.pathname;
  const isStandardOutputPage = locationPathname === PathnameEnum.STANDARD_OUTPUT_PAGE; // 스탠다드 Output 페이지인 경우 true
  const isAdultsOnlyOutputPage = locationPathname === PathnameEnum.ADULTS_ONLY_OUTPUT_PAGE; // 19금 Output 페이지인 경우 true

  const handleSearchResetButtonClick = () => {
    if (isStandardOutputPage) {
      onInitStandard();
    } else if (isAdultsOnlyOutputPage) {
      onInitAdultsOnly();
    }
  };

  return (
    <div style={{ width: 75, ...boxstyle }}>
      <div
        onClick={handleSearchResetButtonClick}
        style={{ height: 24, display: 'flex', flexDirection: 'row', gap: 4, alignItems: 'center', cursor: 'pointer' }}
      >
        <ArrowCircleGray500Icon
          style={{
            width: 14,
            height: 14
          }}
        />
        <Text variant="body2" color={colorSet.gray500}>
          필터 초기화
        </Text>
      </div>
    </div>
  );
};
